import { Component } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-build-message-read-message-two-player',
  templateUrl: './build-message-read-message-two-player.component.html',
  styleUrls: ['./build-message-read-message-two-player.component.css']
})
export class BuildMessageReadMessageTwoPlayerComponent extends GeneralExerciseComponent {

  isLeaved = false;
  isHelperSolutionCorrect = false;
  encodings: number[][] = [];
  encodedMessage: number[] = [];
  isNextPlayer = false;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.encodings = [];
    this.encodedMessage = [];
    this.isLeaved = false;
    this.isHelperSolutionCorrect = false;
    this.solved = false;
    this.isNextPlayer = false;
  }

  checkSolution() {
    if (this.solved) {
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  checkHelperSolution() {
    if (this.isHelperSolutionCorrect) {
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  computeState() {
  }

  generateNextExercise() {
    this.counter++;
    this.initValues();
  }

  setEncodings(encodings: number[][]) {
    this.encodings = encodings;
  }

  setEncodedMessage(message: number[]) {
    this.encodedMessage = message;
  }

  setHelperSolution(isCorrect: boolean) {
    this.isHelperSolutionCorrect = isCorrect;
    this.checkHelperSolution();
  }

  setSolved(solved: boolean) {
    this.solved = solved;
    this.checkSolution();
  }

  setLeaveRoom(isLeaved: boolean) {
    this.isLeaved = isLeaved;
  }

  setNextPlayer() {
    this.isNextPlayer = true;
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
  }
}
